import InfoTitle from './InfoTitle'

export default InfoTitle
